import { render, staticRenderFns } from "./Alarmas.vue?vue&type=template&id=99b3a590&scoped=true&"
import script from "./Alarmas.vue?vue&type=script&lang=js&"
export * from "./Alarmas.vue?vue&type=script&lang=js&"
import style0 from "./Alarmas.vue?vue&type=style&index=0&id=99b3a590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b3a590",
  null
  
)

export default component.exports